import React, { FC } from 'react'
import { CircularProgress } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal } from 'react-bootstrap'
import ActionData from '../../../types/ActionData'
import { capitalize } from 'lodash'
import './index.css'

interface Props {
  isMulti: boolean;
  show: boolean;
  state: ActionData;
  saveText: string;
  savingInProgress: boolean;
  title: string;
  onClose: () => void;
  onAction: () => void;
}

const OverrideValidationWarningModal: FC<Props> = ({ isMulti, show, state, saveText, title, savingInProgress, onClose, onAction }: Props) => {
  let modalText: any
  let subModalText: string
  let style = {}
  const { loading, error, success } = state
  let mainModalIcon
  if (success) {
    mainModalIcon = <FontAwesomeIcon icon={['fas', 'check-circle']} color='#75b465' className='sub-service-code-modal-success-icon' />
    subModalText = 'Success!'
    modalText = saveText
  }

  if (error) {
    const errorText = error.response.text || ''
    mainModalIcon = errorText.includes('could not be notified') ? <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color='orange' className='modal-success-icon' /> : <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color='#cb6767' className='modal-success-icon' />
    subModalText = 'Error!'
    modalText = <div>{(errorText.includes('could not be notified') ? '' : 'The data could not be saved')}<div dangerouslySetInnerHTML={{ __html: error.response.text }} /></div>
    style = { width: '100%' }
  }

  return (
    <Modal size='xl' show={show} onHide={onClose}>
      <Modal.Header closeButton id='model-header'>
        <FontAwesomeIcon icon={['fas', 'exclamation-circle']} size='lg' className='modal-header-icon' />
        <Modal.Title id='modal-header-title'>{capitalize(title)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          loading ? (
            <div style={{ display: 'flex', flexFlow: 'column', alignItems: 'center', padding: 30, width: '100%' }} >
              <CircularProgress size={40} />
              <span>Saving data</span>
            </div>
          ) : (
            <div className='override-validation-modal-loading-container'>
              {!savingInProgress ? <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color='#336699' size='6x' /> : mainModalIcon}
              <span className='override-validation-modal-loading-text'>{!savingInProgress ? 'Warning' : subModalText}</span>
              <span className='override-validation-modal-loading-text' style={style}>
                {!savingInProgress ? `You are about to override the validation of ${isMulti ? 'multiple addresses' : 'an address'}. Are you sure?` : modalText}
              </span>
              <div className='override-validation-actions-cell' style={{ marginTop: 15 }}>
                <Button variant='info' id='override-validation-button' onClick={onClose}>Close</Button>
                {
                  !savingInProgress ? <Button variant='info' id='override-validation-button' onClick={onAction}>Save</Button> : null
                }
              </div>
            </div>
          )
        }
      </Modal.Body>
    </Modal>
  )
}

export default OverrideValidationWarningModal